import {
    CmsBlockContainer as SourceCmsBlockContainer,
} from 'SourceComponent/CmsBlock/CmsBlock.container';
import React from 'react';
import CmsBlock from './CmsBlock.component';

export class CmsBlockContainer extends SourceCmsBlockContainer {
    componentDidUpdate(prevProps) {
        const { identifier } = this.props;
        const { identifier: prevIdentifier } = prevProps;

        if (identifier !== prevIdentifier) {
            this._getCmsBlock();
        }

        const accordianContainer = document.getElementsByClassName('ConatctPage-Faq');

        if (accordianContainer?.length > 0) {
            for (let i = 0; i < accordianContainer?.length; i++) {
                accordianContainer[i].onclick = function () {
                    const active = this.classList.toggle("active");
                };
            }
        }
    }

    render() {
        return (
            <CmsBlock
                {...this.containerProps()}
            />
        );
    }
}

export default CmsBlockContainer;
